import { NewQuestionListPage } from './NewQuestionListPage';
export default NewQuestionListPage;
